import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getParticipantsByActivityId = async (activityId) => {
    if (!activityId) return null;

    const { data } = await vlqrApi.get(`FocusGroupActivities/${activityId}/participants`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const getParticipantsByCrossSessionActivityId = async (crossSessionActivityId) => {
    if (!crossSessionActivityId) return null;

    const { data } = await vlqrApi.get(`FocusGroupActivities/crossSession/${crossSessionActivityId}/participants`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useParticipantsForFocusGroupActivity = ({ activityId, crossSessionId }) => {
    const queryKey = [crossSessionId
        ? 'participantsForCrossSessionActivity'
        : 'participantsForActivity'];
    const queryKeyValue = crossSessionId ?? activityId;

    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: [queryKey, queryKeyValue],

        queryFn: () => crossSessionId
            ? getParticipantsByCrossSessionActivityId(crossSessionId)
            : getParticipantsByActivityId(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default useParticipantsForFocusGroupActivity;
